<template>
  <div id="CollectionsPage" class="grey darken-4 main-content">
    <v-main>
      <v-app-bar>
        <v-container>
          <v-row justify="center">
            <v-col>
              <h2 class="mt-2 mb-2 pl-2">Collections</h2>
            </v-col>
            <v-col>
              <v-select
                v-model="collectionFilterMode"
                :items="filterModes"
                item-text="name"
                item-value="id"
                label="Filter options"
                class="mb-0"
                clearable
                filled
                dense
                solo
                hide-details
                flat
                @change="updateFilterMode()"
              ></v-select>
            </v-col>

            <v-col>
              <v-select
                v-show="
                  collectionFilterMode === 'sharedWith' ||
                  collectionFilterMode === 'sharedBy'
                "
                v-model="collectionClient"
                :loading="isLoading"
                :search-input.sync="collectionClientsSearch"
                :items="clientList"
                :disabled="clientListActive"
                item-text="name"
                item-value="id"
                label="Filter collection by Client"
                class="mb-0"
                clearable
                filled
                dense
                solo
                hide-details
                flat
                @change="collectionSearch()"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                v-model.lazy="searchText"
                label="Search Collections"
                class="mt-2"
                multiple
                chips
                flat
                dense
                clearable
                hide-details
                prepend-icon="mdi-magnify"
                @click:clear="collectionSearch()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>

      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-layout row wrap align-start class="pa-2">
              <CollectionImage
                v-for="(collection, index) in collections"
                :key="index"
                :collection="collection"
                :index="index"
              />
            </v-layout>
          </v-col>
        </v-row>

        <infinite-loading @infinite="loadMoreCollections" ref="infiniteLoading">
          <div class="whitetext" slot="spinner">Loading...</div>
          <div class="whitetext" slot="no-more">No more collections</div>
          <div class="whitetext" slot="no-results">No collections</div>
        </infinite-loading>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import ApiService from "@/common/api.service";
import {
  FETCH_EXPCLIENT_COLLECTIONS,
  COLLECTIONS_RESET_STATE,
} from "@/store/actions.type";

export default {
  name: "CollectionsPage",
  data: () => ({
    activeTab: "all",
    myCollections: false,
    searchText: "",
    clientListActive: true,
    collectionFilterMode: "",
    filterModes: [
      { id: "all", name: "All" },
      { id: "clientCreated", name: "Created by current client" },
      { id: "sharedWith", name: "shared with..." },
      { id: "sharedBy", name: "shared by..." },
    ],
    collectionClient: "",
    isLoading: false,
    collectionClientsSearch: "",
    clientItems: [],
    lastSearch: "",
    debounce: null,
  }),
  computed: {
    clientName() {
      if (this.activeExpClient) {
        return this.activeExpClient.name;
      }
      return "";
    },
    clientList() {
      if (this.activeExpClient) {
        const cList = { name: this.clientName, id: this.activeExpClient.id };
        console.log(this.clientItems);
        this.clientItems.unshift(cList);

        return this.clientItems;
      }
      return [];
    },
    ...mapGetters(["collections", "activeExpClient"]),
  },
  watch: {
    searchText(val) {
      console.log('WATVH');
      if (val !== this.lastSearch && val !== "") {
        this.isLoading = true;

        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          store.dispatch(COLLECTIONS_RESET_STATE);
          this.collectionSearch();
        }, 800);
      }
    },
    collectionClientsSearch(val) {
      if (val !== this.lastSearch) {
        this.isLoading = true;
        this.getRelatedClientList();
      }
    },
  },
  mounted() {},
  destroyed() {
    store.dispatch(COLLECTIONS_RESET_STATE);
  },
  methods: {
    updateFilterMode() {
      this.collectionClient = "";
      if (
        this.collectionFilterMode === "all" ||
        this.collectionFilterMode === "clientCreated"
      ) {
        this.clientListActive = true;
        this.getCollections();
      }

      if (this.collectionFilterMode === "clientCreated") {
        this.clientListActive = true;
      }
      if (this.collectionFilterMode === "sharedWith") {
        this.clientListActive = false;
        this.getPermittedClientList();
      }
      if (this.collectionFilterMode === "sharedBy") {
        this.clientListActive = false;
        this.getRelatedClientList();
      }
    },
    getRelatedClientList() {
      return new Promise((resolve) => {
        ApiService.query("user/related-clients", {
          params: {
            client_id: this.activeExpClient.id,
            per_page: 25,
            where_has_collections: 1,
          },
        })
          .then(({ data }) => {
            this.clientItems = data.data;
            this.isLoading = false;
            resolve(data);
          })
          .catch(({ response }) => {
            return { error: true };
          });
      });
    },

    getPermittedClientList() {
      return new Promise((resolve) => {
        ApiService.query("user/permitted-clients", {
          params: {
            client_id: this.activeExpClient.id,
            per_page: 25,
            where_has_collections: 1,
          },
        })
          .then(({ data }) => {
            this.clientItems = data.data;
            this.isLoading = false;
            resolve(data);
          })
          .catch(({ response }) => {
            return { error: true };
          });
      });
    },

    loadMoreCollections($state) {
      console.log(
        "%cCollectionsPage.vue line:230 $state",
        "color: #007acc;",
        $state
      );
      const params = { client_id: this.$route.params.clientId };

      if (this.searchText) params.search = this.searchText;
      // Get shared with. Using 1 because of php.
      params.include_shared_with = 1;

      if (this.collectionFilterMode === "clientCreated")
        params.client_created = true;

      if (this.collectionFilterMode === "sharedWith") {
        params.return = "shared_with";
        if (this.collectionClient) {
          params.search_client_id = this.collectionClient;
        }
      }
      if (this.collectionFilterMode === "sharedBy") {
        params.return = "shared_to";
        if (this.collectionClient) {
          params.search_client_id = this.collectionClient;
        }
      }

      console.log(
        "%cCollectionsPage.vue line:147 object",
        "color: #007acc;",
        params
      );

      store
        .dispatch(FETCH_EXPCLIENT_COLLECTIONS, params)
        .then((result) => {
          if (result === "complete") {
            $state.complete();
          }
          $state.loaded();
        })
        .catch((err) => {});
    },
    collectionSearch() {
      store.dispatch(COLLECTIONS_RESET_STATE);
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
    getCollections() {
      store.dispatch(COLLECTIONS_RESET_STATE);
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
  },
};
</script>
